'use es6';

import React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
var LANG_ROUTE = 'upgrades.activationModal';

var ActivationErrorModal = function ActivationErrorModal() {
  return React.createElement(UIModal, {
    size: "auto",
    use: "conversational",
    width: 500
  }, React.createElement(UIDialogBody, null, React.createElement(UIErrorMessage, null, React.createElement("p", {
    className: "m-bottom-0"
  }, React.createElement(FormattedMessage, {
    message: LANG_ROUTE + ".errorTitle"
  })), React.createElement("p", null, React.createElement(FormattedMessage, {
    message: LANG_ROUTE + ".errorMessage"
  })))));
};

export default ActivationErrorModal;